import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {AiSparkleNewIcon} from 'shells/icon/svg/ai-sparkle-new-icon';
import {Link} from 'shells/link/link';

import styles from './info.module.css';

const ClickableFields = ['URL', 'Company domain', 'Website'];

type Props = {
    label: string;
    value: string | null | undefined;
    isNew: boolean;
};

export function Info(props: Props) {
    if (!props.value) {
        return <div className={styles.placeholder}></div>;
    }

    return (
        <div className={styles.info}>
            <div className={props.isNew ? styles['label--new'] : styles.label}>{props.label}</div>
            <div className='flex align-center'>
                <div className={props.isNew ? styles['value--new'] : styles.value}>
                    {getFormattedValue(props.value, props.label, props.isNew)}
                </div>
                {/* @ts-expect-error */}
                {props.isNew ? <AiSparkleNewIcon color={colors.company} size={18} /> : undefined}
            </div>
        </div>
    );
}

function getFormattedValue(value: string, label: string, isNew: boolean): React.ReactElement {
    const isClickableField = ClickableFields.includes(label);
    const isHttp = value.startsWith('http') || value.startsWith('https');
    const clickableValue = isClickableField && isHttp ? value : `https://${value}`;
    const linkValue = isClickableField ? clickableValue : value;

    if (isClickableField || isHttp) {
        return (
            <div className={isNew ? styles['link-container--new'] : styles['link-container']}>
                <Link href={linkValue} newTab={true} variant='primary' isBold={true}>
                    {linkValue}
                </Link>
            </div>
        );
    }

    const formattedValue = Number(value) ? Number(value).toLocaleString() : value;

    return <span>{formattedValue}</span>;
}
